import styled from 'styled-components';
import Icon from 'components/icons';

export const IconButton = styled.button.attrs({ type: 'button' })`
	background: transparent;
	border: 0;
	line-height: 1;
	padding: 0;
	cursor: pointer;
	outline: none;

	${Icon} {
		display: block;
	}
`;
